// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5dc3ed0a","453":"8772ac72","461":"176cdc34","942":"dc4e5071"}[chunkId] + ".chunk.js";
};